import { create } from 'zustand';
import type { SubscriptionTier } from '@/types/common';
import { identify } from '@/lib/analytics';

export interface CreatorProfile {
  id: string;
  auth_user_id?: string;
  email: string;
  full_name: string;
  display_name: string | null;
  creator_type: string | null;
  location: string | null;
  pronouns: string | null;
  bio: string | null;
  profile_photo_url: string | null;
  timezone: string;
  subscription_tier: SubscriptionTier;
  subscription_status: 'incomplete' | 'incomplete_expired' | 'active' | 'past_due' | 'canceled' | 'unpaid' | 'paused' | 'inactive';
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  trial_ends_at: string | null;
  onboarding_completed: boolean;
  initial_setup_completed: boolean;
  admin_role: 'support' | 'moderator' | 'admin' | 'owner' | null;
  email_verified_at: string | null;
  // 2FA (TOTP) enabled flag — surfaced by the profile GET so Settings shows the
  // correct enrollment state on load.
  totp_enabled?: boolean;
  pending_email: string | null;
  created_at: string;
  updated_at: string;
}

interface AuthState {
  profile: CreatorProfile | null;
  isLoading: boolean;
  isInitialized: boolean;
  setProfile: (profile: CreatorProfile | null) => void;
  setLoading: (loading: boolean) => void;
  setInitialized: (initialized: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  profile: null,
  isLoading: true,
  isInitialized: false,
  setProfile: (profile) => {
    identify(profile?.id ?? null);
    set({ profile });
  },
  setLoading: (isLoading) => set({ isLoading }),
  setInitialized: (isInitialized) => set({ isInitialized }),
  reset: () => {
    identify(null);
    set({
      profile: null,
      isLoading: false,
    });
  },
}));
